module.exports = function() {
  return new Worker(__webpack_public_path__ + "a836221c81563acf4bc4.worker.js");
};